<!-- 表1填写 -->

<template>
  <div class="tabCage table2">
    <div class="tabTtl">
      <span v-if="pressType == 1">表 1-2：资质情况表 ———— 音像制品出版许可证</span>
      <span v-else>表 1-2：资质情况表 ———— 电子出版物出版许可证</span>
      <!-- <el-select v-model="value" clearable placeholder="历史版本列表" class="selectTime" @change="gethistory(value)">
				 <el-option
						 v-for="item in options"
						 :key="item.id"
						 :label="item.value"
						 :value="item.id">
				 </el-option>
			 </el-select> -->
    </div>
    <div class="headBar">
      <span>出版许可证信息（请按照出版许可证上的信息填写）</span>
    </div>
    <el-form ref="paramCk" :model="params" :rules="rules">
      <div class="editArea editBox">
        <table :class="value !== '' ? 'newStyle' : ''">
          <tr>
            <td class="edName">出版许可证号：</td>
            <td class="edInpBig">
              <el-input style="width: 600px" v-model="params.xkzNum" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">单位名称：</td>
            <td class="edInpBig">
              <el-input v-model="params.orgName" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">单位地址：</td>
            <td class="edInpBig">
              <el-input v-model="params.orgAddr" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">出版者码：</td>
            <td class="edInp">
              <el-input v-model="params.cbzMa" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">法定代表人：</td>
            <td class="edInp">
              <el-input v-model="params.fddbr" disabled size="small"></el-input>
            </td>
          </tr>
          <!-- <tr>
            <td class="edName">有效日期：</td>
            <td class="edInp">
              <el-date-picker
                disabled
                v-model="params.areaDate"
                type="daterange"
                size="small"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </td>
          </tr> -->
          <tr>
            <td class="edName">有效日期：</td>
            <td class="edInp areaTime">
              <el-form-item prop="yxStartDate" :inline-message="true">
                <el-date-picker
                  @change="changeHandle(1)"
                  disabled
                  v-model="params.yxStartDate"
                  value-format="yyyy-MM-dd"
                  placeholder="开始日期"
                  size="small">
                </el-date-picker>
              </el-form-item>
              <span class="midSpan">至</span>
              <el-form-item prop="yxEndDate" :inline-message="true">
                <el-date-picker
                  @change="changeHandle(2)"
                  disabled
                  v-model="params.yxEndDate"
                  value-format="yyyy-MM-dd"
                  placeholder="结束日期"
                  size="small">
                </el-date-picker>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">出版范围：</td>
            <td class="edInpTextArea">
              <el-input type="textarea" :rows="3" v-model="params.businessScope" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">其他主要业务：</td>
            <td class="edInpTextArea">
              <el-input type="textarea" :rows="3" v-model="params.otherScope" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">出版单位设立获批时间：</td>
            <td class="edInp">
              <el-date-picker
                disabled
                v-model="params.approvalTime"
                align="right"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <td class="edName">发文文件：</td>
            <td class="edInp">
              <el-button
                v-if="params.publishFileId"
                size="mini"
                type="warning"
                @click="filesDown(params.publishFileId)">
                下载
              </el-button>
              <span v-if="!params.publishFileId" size="mini" type="danger" style="color: red"> 未上传 </span>
            </td>
          </tr>
          <tr>
            <td class="edName">需要说明的其他情况：</td>
            <td class="edInpTextArea">
              <el-input type="textarea" :rows="3" v-model="params.otherSituation" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName uploadLine">出版许可证：</td>
            <td class="edInp">
              <!-- <span style="color:red;">注：每页只能上传一个图片，上传文件格式为JPEG/PNG，文件大小不超过10M</span> -->
              <br />
              <div class="imgblock">
                <Upbtn
                  class="upBtn"
                  :ableSure="xkzFileId1"
                  @upFileId="fileTdSet1"
                  viewType="2"
                  :btnProps="{ colId: 'xkzFileId1' }" />
                <div class="imgblocktag">出版许可证正本</div>
              </div>
              <div class="imgblock">
                <Upbtn
                  class="upBtn"
                  :ableSure="xkzFileId2"
                  @upFileId="fileTdSet1"
                  viewType="2"
                  :btnProps="{ colId: 'xkzFileId2' }" />
                <div class="imgblocktag">出版许可证副本盖章页</div>
              </div>
              <div class="imgblock">
                <Upbtn
                  class="upBtn"
                  :ableSure="xkzFileId3"
                  @upFileId="fileTdSet1"
                  viewType="2"
                  :btnProps="{ colId: 'xkzFileId3' }" />
                <div class="imgblocktag">出版许可证副本单位信息页</div>
              </div>
              <div class="imgblock">
                <Upbtn
                  class="upBtn"
                  :ableSure="xkzFileId4"
                  @upFileId="fileTdSet1"
                  viewType="2"
                  :btnProps="{ colId: 'xkzFileId4' }" />
                <div class="imgblocktag">出版许可证副本年度核验记录页</div>
              </div>
              <div class="imgblock">
                <Upbtn
                  class="upBtn"
                  :ableSure="xkzFileId5"
                  @upFileId="fileTdSet1"
                  viewType="2"
                  :btnProps="{ colId: 'xkzFileId5' }" />
                <div class="imgblocktag">出版许可证副本变更记录页</div>
              </div>
            </td>
          </tr>
        </table>
        <table :class="value !== '' ? 'newStyle' : ''" v-show="value !== ''">
          <tr>
            <td class="edName">出版许可证号：</td>
            <td class="edInpBig">
              <el-input
                style="width: 600px"
                v-model="historyJsonParams.xkzNum"
                disabled
                size="small"
                :class="historyJsonParams.xkzNum !== params.xkzNum ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">单位名称：</td>
            <td class="edInpBig">
              <el-input
                style="width: 600px"
                v-model="historyJsonParams.orgName"
                disabled
                size="small"
                :class="historyJsonParams.orgName !== params.orgName ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">单位地址：</td>
            <td class="edInpBig">
              <el-input
                style="width: 600px"
                v-model="historyJsonParams.orgAddr"
                disabled
                size="small"
                :class="historyJsonParams.orgAddr !== params.orgAddr ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">出版者码：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.cbzMa"
                disabled
                size="small"
                :class="historyJsonParams.cbzMa !== params.cbzMa ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">法定代表人：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.fddbr"
                disabled
                size="small"
                :class="historyJsonParams.fddbr !== params.fddbr ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">有效日期：</td>
            <td class="edInp">
              <el-date-picker
                disabled
                v-model="historyJsonParams.areaDate"
                type="daterange"
                size="small"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :class="historyJsonParams.areaDate !== params.areaDate ? 'highlight' : ''">
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <td class="edName">出版范围：</td>
            <td class="edInpTextArea">
              <el-input
                type="textarea"
                :rows="8"
                v-model="historyJsonParams.businessScope"
                disabled
                size="small"
                :class="historyJsonParams.businessScope !== params.businessScope ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">其他主要业务：</td>
            <td class="edInpTextArea">
              <el-input
                type="textarea"
                :rows="3"
                v-model="historyJsonParams.otherScope"
                disabled
                size="small"
                :class="historyJsonParams.otherScope !== params.otherScope ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">出版单位设立获批时间：</td>
            <td class="edInp">
              <el-date-picker
                disabled
                v-model="historyJsonParams.approvalTime"
                align="right"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                :class="historyJsonParams.approvalTime !== params.approvalTime ? 'highlight' : ''">
              </el-date-picker>
            </td>
          </tr>

          <tr>
            <td class="edName">需要说明的其他情况：</td>
            <td class="edInpTextArea">
              <el-input
                type="textarea"
                :rows="3"
                v-model="historyJsonParams.otherSituation"
                disabled
                size="small"
                :class="historyJsonParams.otherSituation !== params.otherSituation ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <!-- <tr>
            <td class="edName uploadLine">出版许可证：</td>
            <td class="edInp"> -->
          <!-- <Upbtn @upFileId="fileTdSet" :ableSure="imgId" />
                 <div class="tips">注：上传文件格式为JPGE/PNG，文件大小不超过10M</div> -->
          <!-- <Upbtn :ableSure="fileList" viewType="2" /> -->
          <!-- <el-upload
                                 class="upload_seek"
                                   :action="upUrl"
                                     :file-list="fileList"

                                   list-type="picture-card">
                                   <i class="el-icon-plus"></i>
                              </el-upload> -->
          <!-- <div class="imgfram">
           <img :src="imgUrl" alt="">
                            </div> -->
          <!-- </td>
          </tr> -->
          <tr>
            <td class="edName uploadLine">出版许可证：</td>
            <td class="edInp">
              <!-- <span style="color:red;">注：每页只能上传一个图片，上传文件格式为JPEG/PNG，文件大小不超过10M</span> -->
              <br />
              <div class="imgblock">
                <Upbtn
                  class="upBtn"
                  :ableSure="xkzFileId1"
                  @upFileId="fileTdSet1"
                  viewType="2"
                  :btnProps="{ colId: 'xkzFileId1' }" />
                <div class="imgblocktag">出版许可证正本</div>
              </div>
              <div class="imgblock">
                <Upbtn
                  class="upBtn"
                  :ableSure="xkzFileId2"
                  @upFileId="fileTdSet1"
                  viewType="2"
                  :btnProps="{ colId: 'xkzFileId2' }" />
                <div class="imgblocktag">出版许可证副本盖章页</div>
              </div>
              <div class="imgblock">
                <Upbtn
                  class="upBtn"
                  :ableSure="xkzFileId3"
                  @upFileId="fileTdSet1"
                  viewType="2"
                  :btnProps="{ colId: 'xkzFileId3' }" />
                <div class="imgblocktag">出版许可证副本单位信息页</div>
              </div>
              <div class="imgblock">
                <Upbtn
                  class="upBtn"
                  :ableSure="xkzFileId4"
                  @upFileId="fileTdSet1"
                  viewType="2"
                  :btnProps="{ colId: 'xkzFileId4' }" />
                <div class="imgblocktag">出版许可证副本年度核验记录页</div>
              </div>
              <div class="imgblock">
                <Upbtn
                  class="upBtn"
                  :ableSure="xkzFileId5"
                  @upFileId="fileTdSet1"
                  viewType="2"
                  :btnProps="{ colId: 'xkzFileId5' }" />
                <div class="imgblocktag">出版许可证副本变更记录页</div>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <div class="headBar">
        <span>主办及主管单位信息</span>
      </div>

      <div class="editArea editBox">
        <table :class="value !== '' ? 'newStyle' : ''">
          <tr>
            <td class="edName">主办单位：</td>
            <td class="edInp">
              <el-input style="width: 600px" v-model="params.hostName" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">单位性质：</td>
            <td class="edInp edSelect">
              <el-radio-group disabled v-model="params.hostType">
                <el-radio :label="'1'">中央</el-radio>
                <el-radio :label="'2'">地方</el-radio>
              </el-radio-group>
              <!-- <el-form-item prop="hostType" width="100px">
                <el-radio v-model="params.hostType" label="1">中央</el-radio>
                <el-radio v-model="params.hostType" label="2">地方</el-radio>
              </el-form-item> -->
            </td>
          </tr>
          <tr>
            <td class="edName"></td>
            <td class="edInp edSelect">
              <el-form-item prop="hostCategory" width="200px">
                <el-select
                  disabled
                  v-model="params.hostCategory"
                  width="200px"
                  size="small"
                  placeholder="请选择主办单位性质">
                  <el-option v-for="item in cats" :key="item.code" :label="item.name" :value="item.code"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="params.hostCategory == '5'" prop="hostOtherCategory" :inline-message="true">
                <el-input
                  disabled
                  v-model="params.hostOtherCategory"
                  size="small"
                  placeholder="需要填写具体主办单位性质"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">地址：</td>
            <td class="edInp">
              <el-input style="width: 600px" v-model="params.hostAddr" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">邮政编码：</td>
            <td class="edInp">
              <el-input v-model="params.hostPostalcode" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系人：</td>
            <td class="edInp">
              <el-input v-model="params.hostLinkman" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系电话：</td>
            <td class="edInp">
              <el-input v-model="params.hostTel" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">手机号：</td>
            <td class="edInp">
              <el-input v-model="params.hostPhone" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">主管单位：</td>
            <td class="edInp">
              <el-input style="width: 600px" v-model="params.chargeName" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">单位性质：</td>
            <td class="edInp edSelect">
              <el-radio-group disabled v-model="params.chargeType">
                <el-radio :label="'1'">中央</el-radio>
                <el-radio :label="'2'">地方</el-radio>
              </el-radio-group>
              <!-- <el-form-item prop="chargeType" width="100px">
                <el-radio v-model="params.chargeType" label="1">中央</el-radio>
                <el-radio v-model="params.chargeType" label="2">地方</el-radio>
              </el-form-item> -->
            </td>
          </tr>
          <tr>
            <td class="edName"></td>
            <td class="edInp edSelect">
              <el-form-item prop="chargeCategory" width="200px">
                <el-select
                  disabled
                  v-model="params.chargeCategory"
                  width="200px"
                  size="small"
                  placeholder="请选择主管单位性质">
                  <el-option v-for="item in cats" :key="item.code" :label="item.name" :value="item.code"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="params.chargeCategory == '5'" prop="chargeOtherCategory" :inline-message="true">
                <el-input
                  disabled
                  v-model="params.chargeOtherCategory"
                  size="small"
                  placeholder="需要填写具体主管单位性质"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">地址：</td>
            <td class="edInp">
              <el-input style="width: 600px" v-model="params.chargeAddr" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">邮政编码：</td>
            <td class="edInp">
              <el-input v-model="params.chargePostalcode" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系人：</td>
            <td class="edInp">
              <el-input v-model="params.chargeLinkman" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系电话：</td>
            <td class="edInp">
              <el-input v-model="params.chargeTel" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">手机号：</td>
            <td class="edInp">
              <el-input v-model="params.chargePhone" disabled size="small"></el-input>
            </td>
          </tr>
        </table>
        <table :class="value !== '' ? 'newStyle' : ''" v-show="value !== ''">
          <tr>
            <td class="edName">主办单位：</td>
            <td class="edInp">
              <el-input
                style="width: 600px"
                v-model="historyJsonParams.hostName"
                disabled
                size="small"
                :class="historyJsonParams.hostName !== params.hostName ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">地址：</td>
            <td class="edInp">
              <el-input
                style="width: 600px"
                v-model="historyJsonParams.hostAddr"
                disabled
                size="small"
                :class="historyJsonParams.hostAddr !== params.hostAddr ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">邮政编码：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.hostPostalcode"
                disabled
                size="small"
                :class="historyJsonParams.hostPostalcode !== params.hostPostalcode ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系人：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.hostLinkman"
                disabled
                size="small"
                :class="historyJsonParams.hostLinkman !== params.hostLinkman ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系电话：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.hostTel"
                disabled
                size="small"
                :class="historyJsonParams.hostTel !== params.hostTel ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">手机号：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.hostPhone"
                disabled
                size="small"
                :class="historyJsonParams.hostPhone !== params.hostPhone ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">主管单位：</td>
            <td class="edInp">
              <el-input
                style="width: 600px"
                v-model="historyJsonParams.chargeName"
                disabled
                size="small"
                :class="historyJsonParams.chargeName !== params.chargeName ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">地址：</td>
            <td class="edInp">
              <el-input
                style="width: 600px"
                v-model="historyJsonParams.chargeAddr"
                disabled
                size="small"
                :class="historyJsonParams.chargeAddr !== params.chargeAddr ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">邮政编码：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.chargePostalcode"
                disabled
                size="small"
                :class="historyJsonParams.chargePostalcode !== params.chargePostalcode ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系人：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.chargeLinkman"
                disabled
                size="small"
                :class="historyJsonParams.chargeLinkman !== params.chargeLinkman ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系电话：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.chargeTel"
                disabled
                size="small"
                :class="historyJsonParams.chargeTel !== params.chargeTel ? 'highlight' : ''"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">手机号：</td>
            <td class="edInp">
              <el-input
                v-model="historyJsonParams.chargePhone"
                disabled
                size="small"
                :class="historyJsonParams.chargePhone !== params.chargePhone ? 'highlight' : ''"></el-input>
            </td>
          </tr>
        </table>
      </div>
      <div class="headBar">
        <span>申报人信息</span>
      </div>
      <div class="editArea editBox">
        <table :class="value !== '' ? 'newStyle' : ''">
          <tr>
            <td class="edName">申报人：</td>
            <td class="edInp">
              <el-input v-model="declare.personnel" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系方式：</td>
            <td class="edInp">
              <el-input v-model="declare.contact" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">申报时间：</td>
            <td class="edInp">
              <el-input v-model="params.updatedAt" disabled size="small"></el-input>
            </td>
          </tr>
        </table>
        <table :class="value !== '' ? 'newStyle' : ''" v-show="value !== ''">
          <tr>
            <td class="edName">申报人：</td>
            <td class="edInp">
              <el-input
                v-model="historyDeclare.personnel"
                disabled
                size="small"
                :class="historyDeclare.personnel !== declare.personnel ? 'highlight' : ''">
              </el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系方式：</td>
            <td class="edInp">
              <el-input
                v-model="historyDeclare.contact"
                disabled
                size="small"
                :class="historyDeclare.contact !== declare.contact ? 'highlight' : ''">
              </el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">申报时间：</td>
            <td class="edInp">
              <el-input
                v-model="historyDeclare.updatedAt"
                disabled
                size="small"
                :class="historyDeclare.updatedAt !== params.updatedAt ? 'highlight' : ''">
              </el-input>
            </td>
          </tr>
        </table>
      </div>
    </el-form>
    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
    </div>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsEt2";
import { mebUpdate, tabRead2, pSubmitHistoryList } from "@/api/pressRole/pressRole";
import { detFile } from "@/api/account";
import { getFileToken } from "@/api/account";

import { getPfileUrl } from "@/api/pressRole/pressRole";
// import Upbtn from '@/views/components/upload/uploadCards';
import Upbtn from "@/views/components/upload/uploadSingle";
export default {
  components: {
    Upbtn,
  },
  data() {
    return {
      pressType: "",
      params: bsParams,
      rules: paramsRule,
      submiting: false,
      imgId: "",
      imgUrl: "",
      upUrl: "",
      fileList: "",
      options: [],
      value: "",
      historyJson: [],
      historyJsonParams: {}, // 提交的历史数据json
      historyImgUrl: "", // 提交的历史数据里的img地址
      declare: {
        personnel: "",
        contact: "",
      },
      historyDeclare: {
        personnel: "",
        contact: "",
        updatedAt: "",
      },

      xkzFileId1: "",
      xkzFileId2: "",
      xkzFileId3: "",
      xkzFileId4: "",
      xkzFileId5: "",
      xkzFileId6: "",

      cats: [
        { code: "1", name: "行政机关" },
        { code: "2", name: "事业单位" },
        { code: "3", name: "企业法人" },
        { code: "4", name: "社团法人" },
        { code: "5", name: "其他" },
      ],
    };
  },
  watch: {
    "params.areaDate": function (dat) {
      this.params.yxStartDate = dat[0];
      this.params.yxEndDate = dat[1];
    },
  },
  methods: {
    fileTdSet1: function () {},
    filesDown: function (dat) {
      console.log("发文文件：", dat);
      getPfileUrl({ id: dat }).then((response) => {
        let url = response.payload.url;
        console.log("url=", url);

        window.open(url);
      });
    },
    tabReEdit: function () {
      let vm = this;
      tabRead2({
        publishMaterialId: this.$route.query.mtId,
      }).then((response) => {
        response.pqualification.areaDate = [response.pqualification.yxStartDate, response.pqualification.yxEndDate];
        this.params = response.pqualification;
        this.declare.contact = response.pOrganizationPersonnel.contact;
        this.declare.personnel = response.pOrganizationPersonnel.personnel;
        this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;

        this.publishFileId = response.pqualification.publishFileId;
        this.xkzFileId1 = response.pqualification.xkzFileId1;
        this.xkzFileId2 = response.pqualification.xkzFileId2;
        this.xkzFileId3 = response.pqualification.xkzFileId3;
        this.xkzFileId4 = response.pqualification.xkzFileId4;
        this.xkzFileId5 = response.pqualification.xkzFileId5;
        this.xkzFileId6 = response.pqualification.xkzFileId6;
      });
    },
    // 获取出版单位历史提交版本列表
    getHistoryList: function () {
      let that = this;
      pSubmitHistoryList({
        publishMaterialId: this.$route.query.mtId,
      }).then((response) => {
        that.historyJson = response.pSubmitHistoryList;
        for (const list of response.pSubmitHistoryList) {
          that.options.push({
            value: list.createdAt,
            id: list.id,
          });
        }
      });
    },
    // 获取出版单位历史提交json数据
    gethistory: function (id) {
      const that = this;
      for (const list of that.historyJson) {
        if (id == list.id) {
          that.historyJsonParams = JSON.parse(list.afterJson);
          that.historyDeclare = JSON.parse(list.submittor);
        }
      }
      // 获取图片
      getFileToken().then((data) => {
        that.historyImgUrl =
          process.env.BASE_API +
          "/File/File/download/token/" +
          data.resultStatus.token +
          "/id/" +
          that.historyJsonParams.yyzzId;
      });
    },

    fileTdSet: function (id) {
      this.params.xkzFileId = id;
    },

    goBack: function () {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.getHistoryList();
  },
  created: function () {
    this.tabReEdit();
    this.pressType = this.$route.query.pressType;
    this.upUrl = process.env.BASE_API + "/File/File/upload";
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.highlight {
  .el-input__inner,
  .el-textarea__inner {
    color: red !important;
  }
}

.newStyle {
  margin: 30px 0 !important;
  width: 50% !important;
  overflow: hidden;
  float: left;
}

.table2 {
  margin-top: 0px;

  .imgfram {
    height: 120px;
  }

  .imgfram img {
    height: 120px;
    margin-top: 9px;
  }

  .editBox {
    overflow: hidden;
  }

  .selectTime {
    float: right;
    font-weight: normal;
  }
}

.table2 .edName {
  width: 180px !important;
}

.table2 .uploadLine {
  vertical-align: text-top;
  padding-top: 5px;
}

.table2 .numLine {
  padding-bottom: 15px;
}

.table2 .numInp {
  display: inline-block;
}

.table2 .numInp .inpName {
  display: inline-block;
  width: 150px;
  text-align: right;
}

.table2 .numInp .inpText {
  display: inline-block;
  padding-left: 12px;
}

.table2 .numInp .inpText input {
  border-radius: 0px;
}

.el-date-editor {
  border-radius: 0px;
}

.table2 .el-textarea {
  width: 350px;
}

.table2 .upload_seek .el-upload {
  display: none;
}
</style>



// WEBPACK FOOTER //
// table2.vue?86e59e14